//region :: Imports ::
import MNSwagResult from './NSwagResult';
import MNSwagReplyResult from './NSwagReplyResult';
import NSwagReplyResult from './NSwagReplyResult';
import {forEachProperty} from '../Utils';

//endregion

/** */
class MNSwagAdapter<TClient extends object> {

    private readonly m_client: TClient;

    /** */
    public constructor(client: TClient) {
        this.m_client = client;
    }

    /** */
    public async call(invoke: (client: TClient) => Promise<void>): Promise<MNSwagResult> {

        try {

            await invoke(this.m_client);
            return MNSwagResult.ok();

        } catch(ex: any) {
            return MNSwagResult.notOk(ex);
        }

    }

    /** */
    public async callWithReply<TReply extends object>(
        replyType: { new(): TReply }, invoke: (client: TClient) => Promise<any>): Promise<MNSwagReplyResult<TReply>> {

        try {

            const reply = forEachProperty(new replyType(), await invoke(this.m_client));
            return NSwagReplyResult.ok<TReply>(reply);

        } catch(ex: any) {
            return NSwagReplyResult.notOk<TReply>(ex);
        }

    }

}

export default MNSwagAdapter;
